import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="border-y border-white/10 py-7 overflow-hidden select-none" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-14 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-14 font-display font-bold uppercase text-3xl sm:text-4xl tracking-tight">
            <span className={i % 2 === 0 ? "text-outline" : "text-volt"}>{item}</span>
            <span className="w-2 h-2 bg-volt/60 rotate-45 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
